export const hasAdminAccountAccess = permissions => Boolean(permissions?.is_admin > 0 || permissions?.accessByAdmin)

export const canManageAccounts = permissions => Boolean(
    !permissions?.accessByAdminReadOnly && (
        permissions?.accessByAdmin ||
        ((permissions?.is_admin > 0 || permissions?.is_partner > 0) && permissions?.manage_accounts > 1)
    )
)
